import axios from "axios";
import Vue from "vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

// vuetify conflict style issue
// https://github.com/vuetifyjs/vuetify/issues/8530

// workaround
// https://github.com/vuetifyjs/vuetify/issues/9999
const ignoreWarnMessage = `The .native modifier for v-on is only valid on components but it was used on <div>.`;
// eslint-disable-next-line no-unused-vars
Vue.config.warnHandler = function(msg, vm, trace) {
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};

export default {
  name: "_teams",
  components: {},
  props: [],
  data() {
    return {
      items: [],
      groups: ["A", "B", "C", "D"],

      toCreate: {},
      toEdit: {},
      selectedItem: {},
      selectedUsers: [],
      creating: true,
      file: null,
      fields: [
        "group",
        { key: "logo", Label: "Logo" },
        "name",
        "url",
        { key: "content", label: "Description" },
        {
          key: "users",
          label: "Users"
        },
        {
          key: "actions",
          label: "Actions"
        }
      ]
    };
  },
  computed: {
    teams() {
      return this.$store.getters.getTeams;
    },
    users() {
      return this.$store.getters.getUsers.filter(s =>
        s.roles.includes(this.studentRole?._id)
      );
    },
    studentRole() {
      return this.$store.getters.getRoles.find(r => r.isDefault === true);
    },
    usersToCreate() {
      return this.users.filter(u => !u.team);
    },
    usersToEdit() {
      return this.users.filter(u => !u.team || u.team == this.toEdit._id);
    }
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Backend" },
      { title: "Users", route: "students" },
      { title: "Manage Teams" }
    ]);
  },
  methods: {
    onFileChanged(event) {
      console.log(event);
      this.file = event.target.files[0];
    },
    createItem(evt) {
      evt.preventDefault();
      if (this.file) {
        const formData = new FormData();
        formData.append("file", this.file, this.file.name);
        axios
          .post("/uploadTeams", formData)
          .then(response => {
            this.message = "Uploaded Image";
            this.toCreate.logo = response.data.file.path;
            axios.post("teams?fields=users", this.toCreate).then(() => {
              //console.log(response);
              this.$store.dispatch("fetchTeams");
              this.$store.dispatch("fetchUsers");
              this.toCreate = {};
              this.file = {};
            });
          })
          .catch(err => {
            console.log(err.response);
          });
      } else {
        axios.post("teams?fields=users", this.toCreate).then(() => {
          //console.log(response);
          this.$store.dispatch("fetchTeams");
          this.$store.dispatch("fetchUsers");
          this.toCreate = {};
        });
      }
    },
    getInitials(u) {
      if (!u.avatar) {
        if (!u.firstName || !u.lastName) {
          return u.userName[0] + u.userName[1];
        } else {
          return u.firstName[0] + u.lastName[0];
        }
      }
    },
    deleteItem(id) {
      axios.delete("teams/" + id).then(response => {
        console.log(response);
        this.$store.dispatch("fetchTeams");
        this.$store.dispatch("fetchUsers");
      });
    },
    editItem(id, evt) {
      evt.preventDefault();
      if (this.file) {
        const formData = new FormData();
        formData.append("file", this.file);
        axios.post("upload", formData).then(response => {
          this.message = "Uploaded Image";
          this.toEdit.logo = response.data.file.path;
          axios.put("teams/" + id, this.toEdit).then(response => {
            console.log(response);
            this.$store.dispatch("fetchTeams");
            this.$store.dispatch("fetchUsers");
            this.file = {};
          });
        });
      } else {
        axios.put("teams/" + id, this.toEdit).then(response => {
          this.$store.dispatch("fetchTeams");
          this.$store.dispatch("fetchUsers");
          console.log(response);
        });
      }
      this.creating = true;
    },
    viewItem(item) {
      // let users = [];
      // for (let i = 0; i < item.users.length; i++){
      //   users.push(item.users[i]._id);
      // }
      // item.users = users;
      this.toEdit = item;
      console.log(this.toEdit);
      this.creating = false;
    },
    changeToCreate() {
      this.toEdit = null;
      this.creating = true;
    }
  }
};
